import React, { useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import HotSwapFlowStepper from './components/how-swap-flow-stepper'
import ScheduleServiceStep from './components/us-flow/schedule-service'
import AddressServiceStep from './components/us-flow/address-service'
import HotSwapSummary from './components/how-swap-summary'
import { HOTSWAP_TYPES } from './constants/constants'
import HotSwapSuccess from './hot-swap-success'
import usePostHotSwap from './api/usePostHotSwap'

export default function HotSwapUsFlow({
    selectedHotSwapLocations,
    setSelectedSwapOption
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const formRef = useRef()
    const dateRef = useRef()
    const [formData, setFormData] = useState(null)
    const [scheduledDate, setScheduledDate] = useState(null)
    const [scheduledTime, setScheduledTime] = useState(null)
    const [isConfirmed, setIsConfirmed] = useState(false)
    const hotSwapMutation = usePostHotSwap()

    const steps = useMemo(() => {
        return [
            {
                label: locale.hotSwap.update_service.stepper.firstStepHeader,
                question:
                    locale.hotSwap.update_service.stepper.firstStepSubHeader,
                step: (
                    <ScheduleServiceStep
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        dateRef={dateRef}
                        setScheduledDate={setScheduledDate}
                        setScheduledTime={setScheduledTime}
                    />
                ),
                validate: () => validateDateStep()
            },
            {
                label: locale.hotSwap.update_service.stepper.secondStepHeader,
                question:
                    locale.hotSwap.update_service.stepper.secondStepSubHeader,
                step: (
                    <AddressServiceStep
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        setFormData={values => setFormData(values)}
                        formRef={formRef}
                    />
                ),
                validate: () => validateAddressStep()
            },
            {
                label: locale.hotSwap.update_service.stepper.thirdStepHeader,
                question:
                    locale.hotSwap.update_service.stepper.thirdStepSubHeader,
                step: (
                    <HotSwapSummary
                        selectedHotSwapLocations={selectedHotSwapLocations}
                        swapType={HOTSWAP_TYPES.US}
                        formData={formData}
                        scheduledDate={scheduledDate}
                        scheduledTime={scheduledTime}
                    />
                )
            }
        ]
    }, [
        locale.hotSwap.update_service.stepper,
        selectedHotSwapLocations,
        formData,
        scheduledDate,
        scheduledTime
    ])

    // TODO: update this logic after backend work is done (update hotSwapData setting, maybe move logic for both SBU and US elsewhere)
    function handleConfirm() {
        const hotSwapData = {
            ...formData,
            streetAddress: formData.streetAndNumber,
            streetNumber: 1,
            hotswapType: HOTSWAP_TYPES.US,
            date: scheduledDate,
            time: scheduledTime,
            locations: selectedHotSwapLocations.map(l => l.id)
        }
        hotSwapMutation.mutate(hotSwapData, {
            onSuccess: () => {
                setIsConfirmed(true)
            },
            onError: error => {
                // TODO: show proper error msg
                console.error(error)
            }
        })
    }

    const validateAddressStep = async () => await formRef.current.submit()

    const validateDateStep = () => !!scheduledDate

    return (
        <div className={classes.wrapper}>
            {isConfirmed ? (
                <HotSwapSuccess swapType={HOTSWAP_TYPES.US} />
            ) : (
                <HotSwapFlowStepper
                    steps={steps}
                    setSelectedSwapOption={setSelectedSwapOption}
                    handleConfirm={handleConfirm}
                />
            )}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}))
